import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import StateContext from "../../contextAPI/context";
import BookingSidebar from "./bookingSideBar";
import CreateBooking from "./createBooking";

const Create = (props) => {
  const navigate = useNavigate();
  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      {/* <div className="flex justify-between mb-5">
        <h1 className="text-2xl md:text-3xl text-slate-800 font-bold">
          Create Booking
        </h1>
      </div> */}
      <CreateBooking
      />
    </div>
  );
};
Create.auth = { path: "/booking/create", role: "super-admin admin" };
export default Create;
